enum ELanguage {
  HEBREW = 'עברית',
  ENGLISH = 'English',
  GERMAN = 'de',
  SWISS = 'swiss',
  CANADA = 'ca',
  GREECE = 'gr',
  PHILIPPINES = 'ph',
  SINGAPORE = 'sg',
  AUSTRIA = 'at',
  PORTUGAL = 'pt',
  BELGIUM = 'be',
  AUSTRALIA = 'au',
  IRELAND = 'ie',
  SPAIN = 'es',
  NETHERLANDS = 'nl',
  FINLAND = 'fi',
  ITALY = 'it',
  CHINA = 'cn',
  JAPAN = 'jp',
  POLAND = 'pl',
  BRAZIL = 'br',
  NEW_ZEALAND = 'nz',
  LUXEMBOURG = 'lu',
  FRANCE = 'fr',
  CZECH = 'cz',
  SWEDEN = 'se',
  RUSSIA = 'ru',
  MEXICO = 'mx',
  UK = 'uk',
  UKRAINE = 'ua',
  BULGARIA = 'bg',
  ROMANIA = 'ro',
  DENMARK = 'dk',
  TAIWAN = 'tw',
}

enum EDirection {
  LTR = 'ltr',
  RTL = 'rtl',
}

export { ELanguage, EDirection }
